export enum UploadStatus {
    INITIAL = 0,
    SUCCESS = 1,
    ERROR = 2,
    CANCELED = 3,
    WARNING = 4,
    PENDING
}
